import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { PayPeriod } from 'src/app/store/application';


@Injectable()
export class PayPeriodService {
    apiUrl = 'api/payperiod';

    httpOptions = {
        headers: new HttpHeaders({
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        })
    };

    constructor(private httpClient: HttpClient) { }

    getPayPeriod(year: string): Observable<PayPeriod[]> {
        return this.httpClient.get<PayPeriod[]>(this.apiUrl + "/" + year, this.httpOptions);
    }

    getAllPayPeriods(): Observable<PayPeriod[]> {
        return this.httpClient.get<PayPeriod[]>(this.apiUrl, this.httpOptions);
    }

}
